export enum actionTypes {
    REQUEST_RESTRICTED_FILE_TYPES = "request_restricted_file_types",
    RECEIVE_RESTRICTED_FILE_TYPES = "receive_restricted_file_types",
    COMPLETE_RESTRICTED_FILE_TYPES = "complete_restricted_file_types",
}